import { DropzoneArea } from '../../material-ui-dropzone';
import React, { Component,useContext } from 'react';
import ActionsContextV2 from '../ActionsContextV2';

 
 
const ActionFileUploads = () => {
    
    const context = useContext(ActionsContextV2);

    return (
      <DropzoneArea
        style={{minHeight:200}}
        filesLimit={1000}
        showAlerts={false}
        showPreviews={false}
        showPreviewsInDropzone={false}
        dropzoneText="Drag files here or click to browse" 
        onChange={files => {
          console.log("DropzoneArea onChange" + JSON.stringify(files))
          context.updateDeviationFiles(files);
        }}/>
        
    )  
}
 
 
export default ActionFileUploads;